import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { cn } from '@/utils/cn';
import { getUiIntlLocale } from '@/i18n/languageContext';
import { intlWeekdayLabels } from '@/utils/intlCalendar';

export function CalendarWeekdayHeader({ className }: { className?: string }) {
  const { i18n } = useTranslation();
  const labels = useMemo(
    () => intlWeekdayLabels(getUiIntlLocale()),
    [i18n.language],
  );

  return (
    <div className={cn('mb-1 grid grid-cols-7 gap-0.5', className)}>
      {labels.map((label) => (
        <div key={label} className="calendar-weekday">
          {label}
        </div>
      ))}
    </div>
  );
}
